!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t() : "function" == typeof define && define.amd ? define(t) : t();
}(0, function () {
  var e = Object.assign || function (e) {
    for (var t = arguments, n = 1; n < arguments.length; n++) {
      var r = t[n];

      for (var i in r) {
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
      }
    }

    return e;
  },
      t = r(require("react")),
      n = r(require("prop-types"));

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var i = function i(n) {
    var r = n.color,
        i = n.speed,
        a = n.gap,
        o = n.thickness,
        s = n.size,
        l = function (e, t) {
      var n = {};

      for (var r in e) {
        t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }

      return n;
    }(n, ["color", "speed", "gap", "thickness", "size"]);

    return t.default.createElement("svg", e({
      height: s,
      width: s
    }, l, {
      style: {
        animationDuration: function (e) {
          return "fast" === e ? 600 : "slow" === e ? 900 : 750;
        }(i) + "ms"
      },
      className: "__react-svg-spinner_circle",
      role: "img",
      "aria-labelledby": "title desc",
      viewBox: "0 0 32 32"
    }), t.default.createElement("title", {
      id: "title"
    }, "Circle loading spinner"), t.default.createElement("desc", {
      id: "desc"
    }, 'Image of a partial circle indicating "loading."'), t.default.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: "\n      .__react-svg-spinner_circle{\n          transition-property: transform;\n          animation-name: __react-svg-spinner_infinite-spin;\n          animation-iteration-count: infinite;\n          animation-timing-function: linear;\n      }\n      @keyframes __react-svg-spinner_infinite-spin {\n          from {transform: rotate(0deg)}\n          to {transform: rotate(360deg)}\n      }\n    "
      }
    }), t.default.createElement("circle", {
      role: "presentation",
      cx: 16,
      cy: 16,
      r: 14 - o / 2,
      stroke: r,
      fill: "none",
      strokeWidth: o,
      strokeDasharray: 2 * Math.PI * (11 - a),
      strokeLinecap: "round"
    }));
  };

  i.propTypes = {
    color: n.default.string,
    thickness: n.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8]).isRequired,
    gap: n.default.oneOf([1, 2, 3, 4, 5]).isRequired,
    speed: n.default.oneOf(["fast", "slow"]),
    size: n.default.string.isRequired
  }, i.defaultProps = {
    color: "rgba(0,0,0,0.4)",
    gap: 4,
    thickness: 4,
    size: "1em"
  }, module.exports = i;
});